import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { fetchShipments, setShipmentVisibility } from '../../../../actions/shipmentsActions';
import { ShipmentDirection } from '../../../../@posturinn/client-react';
import * as StyledModals from '../myShipmentsModals.styles';
import Button from '../../../base/button';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from '../../../../store';
import { UnknownAction } from 'redux';


interface Props {
	shipmentId: string;
	onClose: () => void;
	page?: number;
	modalHeading: string;
	direction: ShipmentDirection;
	includeHidden: boolean;
}

const HideShipmentModal: FC<Props> = ({ shipmentId, onClose, page, modalHeading, direction, includeHidden}) => {
	const { t } = useTranslation('myShipments');
	const dispatch = useDispatch<ThunkDispatch<RootState, void, UnknownAction>>();
	
	const [errorMessage, setErrorMessage] = React.useState(null);
	
	const handleHideShipment = async () => {
		try {
			await dispatch(setShipmentVisibility(shipmentId, true));
			await dispatch(fetchShipments(page || 1, true, direction, includeHidden));
			await dispatch(fetchShipments(page || 1, false, direction, includeHidden));
			onClose();
		} catch (err) {
			console.error(err);
			setErrorMessage(t('genericError'));
		}
	};
	const stopPropagation = e => {
		e.stopPropagation();
	};
	
	return (
		<StyledModals.WrapperV2 onClick={onClose}>
			<StyledModals.ModalOverlay />
			<StyledModals.ModalForm onClick={stopPropagation}>
				<StyledModals.WhiteBox>
					<StyledModals.ModalHeader>
						<div>{modalHeading}</div>
					</StyledModals.ModalHeader>
					{errorMessage && <StyledModals.ErrorMessage>{errorMessage}</StyledModals.ErrorMessage>}
					<StyledModals.ModalActions>
						<Button onClick={onClose}>
							{t('no')}
						</Button>
						<Button primary onClick={handleHideShipment}>
							{t('yes')}
						</Button>
					</StyledModals.ModalActions>
				</StyledModals.WhiteBox>
			</StyledModals.ModalForm>
		</StyledModals.WrapperV2>
	);
};

export default HideShipmentModal;
